import { differenceInDays, parse } from 'date-fns';

/**
 * Calculates the number of days between the current date and a given date string.
 *
 * @param date - The date string to compare with the current date.
 * @param inputDateFormat - The format of the input date string.
 * @returns The number of days between the current date and the given date.
 */
export const getDaysSinceNow = (
  date: string,
  inputDateFormat = 'MM/dd/yy'
): number => {
  const now = new Date();
  const scan = parse(date, inputDateFormat, new Date());

  return differenceInDays(now, scan);
};
